import Teachers from './teacher_module'
import Student from './student_module'
import Train from './trainers_module'
import http_service from "../classes/http";
import { bus } from '../other/bus'

let http = new http_service(bus);

export default {
  modules: {
    teacher: Teachers,
    student: Student,
    train: Train,
  },
  state: {
    user: '',
    trainers: '',
    current_trainer: '',
    current_stat: '',
    /** Платная платформа */
    prices: {
      subscribe: 1500,
      solo_student: 390,
      per_student: 250,
      students_in_subscribe: 5
    },
    /** Коэффицент за домашку*/
    hw_coefficient: 1.3,
    /** Цвета для рамок */
    colors: [
      '#be6fc6',
      '#58d87c',
      '#f8d937',
      '#ff4646',
      '#0080da',
      '#532664',
      '#fcca68',
      '#c9132c',
      '#ffb4d5',
      '#00b1f5',
      /* 'Lime',
       'Red',
       'DeepPink',
       'OrangeRed',
       'YellowGreen',
       'Cyan',
       'Yellow',
       'DeepSkyBlue',
       'Blue',
       'Magenta',
       'Crimson',
       'Gold',
       'Green',
       'Purple',*/
    ],

    /** РЕАКЦИИ */
    react_minus: [
      'drakon_chitaet_(neytralnaya).mp4',
      'drakon_est_bukvy_(otricatelnaya).mp4',
      'drakon_v_zasade_(otricatelnaya).mp4',
      'reakciya_1._zhora_s_tuchkoy.mp4',
      'reakciya_2._zhora_s_bukvami_v_zhivote.mp4',
      'reakciya_3._zhora_na_loshadi.mp4',
      'reakciya_7._zhora_bolelschik.mp4',
      'reakciya_8._zhora_s_plakatami.mp4',
      'reakciya_9._zhora_s_sekundomerom.mp4',
    ],
    react_plus: [
      'drakon_chitaet_(neytralnaya).mp4',
      'drakon_s_gramotoy_(polozhitelnaya).mp4',
      'drakon_s_muhoboykoy_(polozhitelnaya).mp4',
      'reakciya_4._zhora_bogach.mp4',
      'reakciya_5._zhora_garri_potter.mp4',
      'reakciya_6._zhora_s_cvetkom.mp4',
      'reakciya_7._zhora_bolelschik.mp4',
      'reakciya_8._zhora_s_plakatami.mp4',
      'reakciya_9._zhora_s_sekundomerom.mp4',
    ],
  },
  mutations: {
    setUser(state, user) {
      if (!user.property) {
        user.property = {}
      }
      state.user = user;
    },
    setCurrentTrainer(state, item) {
      state.current_trainer = item;
    },
    setCurrentStat(state, items) {
      state.current_stat = items;
    },
    shuffleColors(state) {
      state.colors = _.shuffle(state.colors);
    },
    changeUserScores(state, scores) {
      state.user.scores = state.user.scores + scores;
    },
    updateUserStatus(state, status) {
      state.user.status = status;
    },
    updateUserParam(state, val) {
      state.user[val.param] = val.value;
    }
  },
  actions: {
    async getCurrentTrainer(ctx, id) {
      let trainer = await http.post('onGetCurrentTrainer', { id }).then(res => res.data)
      console.log(trainer)
      ctx.commit('setCurrentTrainer', trainer);
    },
    async saveStats(ctx, arr) {
      let stat = await http.post('onSaveStats', { stat: arr }).then(res => res.data)
      // ctx.commit('setCurrentStat', stat);
    }
  },
  getters: {
    user(state) {
      return state.user
    },
    currentTrainer(state) {
      return state.current_trainer
    }
  }
}